export const roleMap = new Map([
  [0, "Eier"],
  [1, "Administrator"],
  [2, "Medlem"],
]);
